import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { handleLoginCallback } from './services/auth';

async function boot() {
  // Handle Okta callback before mounting the app
  if (window.location.pathname === '/login/callback') {
    try {
      const redirectTo = await handleLoginCallback();
      window.location.replace(redirectTo);
      return;
    } catch (error) {
      console.error('Login callback failed:', error);
      window.location.replace('/');
      return;
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

boot();
